<template>
  <div class="container">
    <div class="topContainer">
      <el-form :model="form" style="width: 80%;" ref="refForm" :rules="rules" label-width="180px">
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.deliveryInformation')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.productOrderNo') + ':'" prop="productOrderNo">
              <el-input
                v-model.trim="form.productOrderNo"
                disabled
                name="productOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.orderTime') + ':'" prop="orderDate">
              <el-input
                v-model.trim="form.orderDate"
                disabled
                name="orderDate"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.status') + ':'" prop="status">
              <el-select
                v-model="form.status"
                disabled
                clearable
                filterable
                style="width: 150px;"
                size="small">
                <el-option
                  v-for="(item, key) in prodOrderStatus"
                  :key="key"
                  :label="item.explain"
                  :value="item.val">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.expectedDeliveryNumber') + ':'" prop="expectCount">
              <el-input
                v-model.trim.number="form.expectCount"
                disabled
                type="tel"
                autocomplete="on"
                clearable
                size="small"
                maxlength="10"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.customerInformation')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.customerName') + ':'" prop="customerId">
              <el-select
                v-model="form.customerId"
                :disabled="isFinished"
                clearable
                filterable
                style="width: 100%;"
                size="small"
                @change="changeCustomer">
                <el-option
                  v-for="item in customersList"
                  :key="item.id"
                  :label="item.customerName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.contact') + ':'" prop="contact">
              <el-input
                v-model.trim="form.contact"
                :disabled="isFinished"
                name="contact"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="16">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.contactPhone') + ':'" prop="contactPhone">
              <el-input
                v-model.trim="form.contactPhone"
                :disabled="isFinished"
                name="contactPhone"
                type="tel"
                autocomplete="on"
                clearable
                size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.address') + ':'" prop="contactAddr">
              <el-input
                v-model.trim="form.contactAddr"
                :disabled="isFinished"
                name="incoOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="20">
            <el-form-item :label="$t('common.comment') + ':'">
              <el-input
                v-model="form.comment"
                :disabled="isFinished"
                name="comment"
                type="textarea"
                autocomplete="on"
                clearable
                size="small"
                maxlength="200"
                show-word-limit
                rows="4">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.expressInformation')}}</h4>
        </el-form-item>
        <el-form-item v-if="isSend" label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.expressageNo') + ':'" prop="expressageNo">
              <el-input
                v-model.trim="form.expressageNo"
                name="expressageNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.expressageType') + ':'" prop="expressageType">
              <el-select
                v-model="form.expressageType"
                :disabled="isFinished"
                clearable
                filterable
                style="width: 100%;"
                size="small">
                <el-option
                  v-for="(item, key) in expressageTypes"
                  :key="key"
                  :label="item.explain"
                  :value="item.val">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.expressage') + ':'" prop="expressage">
              <el-select
                v-model="form.expressage"
                :disabled="isFinished"
                clearable
                filterable
                style="width: 100%;"
                size="small">
                <el-option
                  v-for="(item, key)  in expressages"
                  :key="key"
                  :label="item.explain"
                  :value="item.val">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item v-if="isSend || isFinished" label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('deliveryGoods.expressReturnTicket') + ':'" prop="attachment">
              <el-upload
                :headers="headers"
                :action="action"
                :on-success="handleSuccess"
                :on-remove="handleRemove"
                :before-upload="handleBeforeUpload"
                :on-error="handleError"
                :on-preview="handlerPreview"
                :file-list="fileList"
                multiple>
                <el-button size="small" type="plain">{{$t('incomingOrder.upload')}}</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('common.binLevel')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.binLevel')" prop="binLevelArr">
              <el-select
                :disabled="isSend || isFinished"
                v-model="form.binLevelArr"
                clearable
                multiple
                filterable
                style="width: 100%;"
                size="small">
                <el-option
                  v-for="(item, index) in 8"
                  :key="index"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.associatedBoxes')}}</h4>
        </el-form-item>
      </el-form>
      <div class="target-container">
        <el-table
          ref="table"
          border
          :data="prodStores"
          :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
          :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
          header-cell-class-name="headerCellName"
          :span-method="objectSpanMethod">
          <el-table-column prop="incoOrderNo" :label="$t('common.orderNo')">
          </el-table-column>
          <el-table-column prop="subNo" :label="$t('common.subNo')">
          </el-table-column>
          <el-table-column prop="boxNo" :label="$t('common.boxNo')"/>
          <el-table-column prop="binLevel" :label="$t('common.binLevel')"/>
          <el-table-column :label="$t('common.productName')" width="200">
            <template slot-scope="scope">
              {{productName(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column prop="lotNo" :label="$t('common.lotNo')"/>
          <el-table-column :label="$t('common.processType')">
            <template slot-scope="scope">
              {{processTypeVal(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column prop="allCount" :label="$t('common.count')"/>
          <el-table-column :label="$t('common.passCount')">
            <template slot-scope="scope">
              {{scope.row.binLevel !== 8 ? scope.row.count : 0}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.failCount')">
            <template slot-scope="scope">
              {{scope.row.binLevel === 8 ? scope.row.count : 0}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="control-container">
      <div>
        <el-button @click="backOrderListPage" size="small">
          {{$t('common.cancel')}}
        </el-button>
        <el-button v-if="prodStores && prodStores.length > 0" @click="exportXlsx" size="small" type="primary">
          {{$t('deliveryGoods.saveXLSX')}}
        </el-button>
        <el-button :loading="loadingUpdate" @click="submitForm" size="small" class="sure-button">
          {{$t('common.update')}}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import {prodOrderUpdate, prodOrderDetailById, productOrderNoConfirm} from '@/api/prodOrder';
  import { customersList } from '@/api/customers';
  import { consignorsList } from '@/api/consignors';
  import {
    validateContactPhone,
  } from '@/utils/validate';
  import {
    prodOrderStatus,
    priorityLevels,
    processTypes,
    storeStatus,
    expressages,
    expressageTypes,
  } from '@/utils/defines';
  import { isValueEmpty, isPositiveIntegerNum } from '@/utils';
  import exportInvoiceXlsx from '@/utils/exportInvoice';

  const FAIL_BIN = 8;

  const defaultForm = {
    productOrderNo: undefined,
    orderDate: undefined,
    customerId: undefined,
    contact: undefined,
    contactPhone: undefined,
    contactAddr: undefined,
    comment: undefined,
    expressageNo: undefined,
    expressageType: undefined,
    expressage: undefined,
    priorityLevel: undefined,
    status: undefined,
    attachment: undefined,
    expectCount: undefined,
    binLevelArr: undefined,
  };

  export default {
    name: 'check-info',
    props: [
      'productOrder',
    ],
    data() {
      const prodOrderStatusObj = {};
      let prodOrderStatueItem;
      for (const key in prodOrderStatus) {
        if (Object.prototype.hasOwnProperty.call(prodOrderStatus, key)) {
          prodOrderStatueItem = prodOrderStatus[key];
          prodOrderStatusObj[prodOrderStatueItem.val] = prodOrderStatueItem.prodOderExplain || prodOrderStatueItem.explain;
        }
      }
      const processTypesObj = {};
      let processTypeItem;
      for (const key in processTypes) {
        if (Object.prototype.hasOwnProperty.call(processTypes, key)) {
          processTypeItem = processTypes[key];
          processTypesObj[processTypeItem.val] = processTypeItem.explain;
        }
      }
      const storeStatusObj = {};
      let storeStatueItem;
      for (const key in storeStatus) {
        if (Object.prototype.hasOwnProperty.call(storeStatus, key)) {
          storeStatueItem = storeStatus[key];
          storeStatusObj[storeStatueItem.val] = storeStatueItem.prodOderExplain || storeStatueItem.explain;
        }
      }
      const validateAttachment = (rule, value, callback) => {
        if (this.isFinished) {
          if (!value ||  value && value.length === 0) {
            callback(new Error(this.$t('deliveryGoods.returnTicketCanNotBeEmpty')));
            return;
          }
        }
        callback();
      };
      return {
        form: Object.assign({}, defaultForm),
        rules: {
          productOrderNo: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.productOrderNoCanNotBeEmpty') }],
          orderDate: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.orderTimeCanNotBeEmpty') }],
          status: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.statusCanNotBeEmpty') }],
          expectCount: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expectedDeliveryNumberCanNotBeEmpty') }],
          customerId: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.customerNameCanNotBeEmpty') }],
          contact: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.contactCanNotBeEmpty') }],
          contactPhone: [{ required: true, trigger: 'blur', validator: validateContactPhone }],
          contactAddr: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.contactCanNotBeEmpty') }],
          expressageNo: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageNoCanNotBeEmpty') }],
          expressageType: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageTypeCanNotBeEmpty') }],
          expressage: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageCanNotBeEmpty') }],
          attachment: [{ trigger: 'blur', validator: validateAttachment }],
          binLevelArr: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.binLevelArrCanNotBeEmpty') }],
        },
        customersList: [],
        prodOrderStatus,
        processTypesObj,
        storeStatusObj,
        expressages,
        expressageTypes,
        prodStores: [],
        productOrderNo: undefined,
        tempRoute: {},
        fileList: [],
        loadingUpdate: false,
        fromRoute: {},
        detailProdStores: [],
      };
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.fromRoute = from;
      });
    },
    computed: {
      ...mapGetters([
        'token',
      ]),
      isSend() {
        const {
          status
        } = this.form;
        return status === prodOrderStatus.send.val;
      },
      isFinished() {
        const {
          status
        } = this.form;
        return status === prodOrderStatus.finished.val;
      },
      headers() {
        return {
          Authorization: `Bearer ${this.token}`,
        };
      },
      action() {
        return '/api/v1/files/prodOrder';
      },
    },
    mounted() {
      this.productOrderNo = this.$route.params && this.$route.params.productOrderNo;
      this.customersListGet(1, 200);
      this.prodOrderDetailById();
      this.tempRoute = Object.assign({}, this.$route);
    },
    methods: {
      submitForm() {
        this.$refs.refForm.validate(async (valid) => {
          if (valid) {
            this.prodOrderUpdate();
          }
        });
      },
      async prodOrderUpdate() {
        const {
          isSend,
          isFinished
        } = this;
        const {
          productOrderNo,
          orderDate,
          customerId,
          contact,
          contactPhone,
          contactAddr,
          comment,
          expressageNo,
          expressageType,
          expressage,
          priorityLevel,
          attachment,
          binLevelArr,
        } = this.form;
        this.loadingUpdate = true;
        let fileList = [];
        if (attachment && attachment.length > 0) {
          fileList = attachment.map(item => {
            return item.name;
          });
        }
        try {
          await prodOrderUpdate({
            productOrderNo: productOrderNo || undefined,
            orderDate: orderDate || undefined,
            customerId: customerId || undefined,
            contact: contact || undefined,
            contactPhone: contactPhone || undefined,
            contactAddr: contactAddr || undefined,
            comment: comment || undefined,
            expressageNo: expressageNo || undefined,
            expressageType: expressageType || undefined,
            expressage: expressage || undefined,
            priorityLevel: priorityLevel || undefined,
            binLevelArr,
          });
          if (fileList && fileList.length > 0) {
            await productOrderNoConfirm({
              productOrderNo: productOrderNo || undefined,
              attachment: fileList
            });
          }
          this.$message({
            type: 'success',
            message: this.$t('common.updateSuccess'),
          });
          this.backOrderListPage();
        } catch (e) {
          // do nothing.
        } finally {
          this.loadingUpdate = false;
        }
      },
      changeCustomer(val) {
        const {
          contact,
          contactPhone,
          contactAddr,
        } = this.form;
        if (val) {
          for (const row of this.customersList) {
            if (row.id === val) {
              this.form.contact = row.contact;
              this.form.contactPhone = row.contactPhone;
              this.form.contactAddr = row.contactAddr;
              this.$refs.refForm.validateField(['customerId', 'contact', 'contactPhone', 'contactAddr']);
              break;
            }
          }
        }
      },
      async customersListGet(page, perpage) {
        try {
          const res = await customersList({ page, perpage });
          const { data } = res;
          this.customersList = data.records;
        } catch (e) {
          // do nothing.
        }
      },
      async prodOrderDetailById() {
        const {
          productOrderNo,
        } = this;
        try {
          const res = await prodOrderDetailById({ productOrderNo });
          const {
            data,
          } = res;
          if (data) {
            const {
              productOrderNo,
              createAt,
              customerId,
              contact,
              contactPhone,
              contactAddr,
              comment,
              expressageNo,
              expressageType,
              expressage,
              priorityLevel,
              prodStores,
              status,
              attachment,
              expectCount,
              binLevelData,
            } = data.detail;
            this.detailProdStores = prodStores;
            this.form = {
              productOrderNo,
              orderDate: this.formatDate(createAt),
              customerId,
              contact,
              contactPhone,
              contactAddr,
              comment,
              expressageNo,
              expressageType,
              expressage,
              priorityLevel,
              status,
              attachment: undefined,
              expectCount,
              binLevelArr: binLevelData,
            };
            this.prodStores = [];
            let length, info, count, index = 0;
            for (let row of prodStores) {
              info = row.info;
              count = row.count;
              length = info.length;
              for(let i = 0; i < length; i++) {
                if (i === 0) {
                  this.prodStores.push({
                    ...row,
                    ...info[i],
                    rowspan: length,
                    allCount: count,
                    index,
                  });
                } else {
                  this.prodStores.push({
                    ...row,
                    ...info[i],
                    allCount: count,
                  });
                }
              }
            }
            if (attachment) {
              this.fileList = [];
              this.form.attachment = [];
              try {
                const file = JSON.parse(attachment);
                for (let row of file) {
                  this.form.attachment.push({
                    name: row,
                    url: this.attachmentUrl(row),
                  });
                  this.fileList.push({
                    name: row,
                    url: this.attachmentUrl(row),
                  });
                }
              } catch(e) {
                // do nothing.
              }
            }
          }
        } catch (e) {
          // do nothing.
        }
      },
      processTypeVal(row) {
        const {
          processType
        } = row;
        return this.processTypesObj[processType];
      },
      storeStatusVal(val) {
        return this.storeStatusObj[`${val}`];
      },
      productName(row) {
        const {
          productName,
          chipName,
        } = row;
        if (!productName || !chipName) {
          return '';
        }
        return `${productName} / ${chipName}`;
      },
      formatDate(date) {
        if (!date) {
          return '';
        }
        const updateDate = moment.utc(date);
        const isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
        if (isSameYear) {
          return updateDate.local().format('MM/DD HH:mm:ss');
        }
        return updateDate.local().format('YYYY/MM/DD HH:mm:ss');
      },
      handleSuccess(response, file, fileList) {
        this.form.attachment = fileList;
      },
      handleError() {
      },
      handleRemove(file, fileList) {
        this.form.attachment = fileList;
      },
      handlerPreview(file) {
        const url = this.attachmentUrl(file.name);
        window.open(url, 'blank');
      },
      handleBeforeUpload(file) {
        const isLessThan2M = file.size / 1024 / 1024 < 2;
        if (!isLessThan2M) {
          this.$message({
            type: 'error',
            message: this.$t('common.sizeNotExceed2M'),
          });
        }
        return isLessThan2M;
      },
      attachmentUrl(attachment) {
        return `${window.location.protocol}//${window.location.hostname}:${window.location.port}/prodOrder/${attachment}`;
      },
      backOrderListPage() {
        const {
          fromRoute,
          tempRoute,
        } = this;
        if (fromRoute.path === '/') {
          this.$router.replace({ path: '/redirect/deliver-history' });
        } else {
          this.$router.replace({ path: '/redirect' + fromRoute.path });
        }
        this.$store.dispatch('tagsView/delView', tempRoute);
      },
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 2 || columnIndex === 3 || columnIndex === 7) {
          if (row.rowspan) {
            return {
              rowspan: row.rowspan,
              colspan: 1,
            };
          }
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      },
      exportProdStores() {
        const detailProdStores = this.detailProdStores;
        let prodStores = [];
        let length, info, count, badChipInfoCount, directrix = 0, prodStoresItemArray;
        for (const row of detailProdStores) {
          info = row.info;
          count = row.count;
          length = info.length;
          badChipInfoCount = 0;
          prodStoresItemArray = [];
          for (let i = 0; i < length; i++) {
            if (row.binLevel === FAIL_BIN) {
              for (let [key, val] of Object.entries(info[i].badChipInfo)) {
                if (badChipInfoCount === 0) {
                  prodStoresItemArray.push({
                    ...row,
                    ...info[i],
                    binLevelVal: key,
                    count: val,
                    rowspan: Object.keys(info[i].badChipInfo).length,
                    allCount: count,
                  });
                } else {
                  prodStoresItemArray.push({
                    ...row,
                    ...info[i],
                    binLevelVal: key,
                    count: val,
                    rowspan: length,
                    allCount: count,
                  });
                }
                badChipInfoCount++;
              }
            } else {
              if (i === 0) {
                prodStoresItemArray.push({
                  ...row,
                  ...info[i],
                  binLevelVal: 'A',
                  rowspan: length,
                  allCount: count,
                });
              } else {
                prodStoresItemArray.push({
                  ...row,
                  ...info[i],
                  binLevelVal: 'A',
                  rowspan: length,
                  allCount: count,
                });
              }
            }
          }
          prodStoresItemArray.sort((a, b) => b.count - a.count);
          for (let i = 1, arrayLength = prodStoresItemArray.length; i < arrayLength; i++) {
            prodStoresItemArray[i].rowspan = undefined;
          }
          prodStores = prodStores.concat(prodStoresItemArray);
          if (row.binLevel === FAIL_BIN) {
            prodStores[directrix].rowspan = badChipInfoCount === 1 ? undefined : badChipInfoCount;
            directrix = badChipInfoCount;
          } else {
            directrix = length;
          }
        }
        return prodStores;
      },
      async exportXlsx() {
        const productOrderNo = this.form.productOrderNo;
        const prodStores = this.exportProdStores();
        try {
          const resConsignors = await consignorsList({
            perpage: 10,
            page: 1,
          });
          const consignorsData = resConsignors.data;
          let consignor = {};
          if (consignorsData && consignorsData.records && consignorsData.records.length > 0) {
            consignor = consignorsData.records[0];
          }
          const {
            contactAddr,
            expressage,
          } = this.form;
          const expressages = this.expressages;
          exportInvoiceXlsx({
            consignor,
            prodStores,
            productOrderNo,
            contactAddr,
            expressage: expressages[expressage].explain,
          });
        } catch (e) {
            // do nothing.
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }
  .topContainer {
    height: 100%;
    overflow: auto;
    flex: 1;
  }
  .el-form {
    padding: 10px 20px 0;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }
  .control-container {
    background: #F5F5F5;
    padding: 20px;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: center;
  }
  .target-container {
    margin: 20px;
  }
  .bottom-container {
    text-align: center;
    position: relative;
    margin: 20px auto;
    width: 100%;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
  .prev-button {
    background: white;
    color: #EC7900;
    border: #EC7900 solid 1px;
  }
  .sure-button {
    background: #EC7900;
    color: white;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }
  .small_label .el-form-item__label {
    font-size: 12px;
  }
</style>
